module.exports = __webpack_public_path__ + "static/flags/BB-452ff2a30a0c7edb9dc15663639c6c97.gif";